<script lang="ts">
import { useEventStore } from '@/stores/event'
import { useEventTypeStore } from '@/stores/eventTypeStore'
import { storeToRefs } from 'pinia'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { computed, onBeforeMount } from 'vue'

export default {
    async beforeRouteEnter(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
        const eventStore = useEventStore()    
        if (!isNaN(parseInt(to.params['id']))) {
            await Promise.all([useEventTypeStore().loadAll(), eventStore.getEvent(parseInt(to.params['id'] as string, 10))])
        next()
        }
    }
}
</script>
<script setup lang="ts">
import { useEventStore } from '@/stores/event'
import { storeToRefs } from 'pinia'
import TheEvent from '@/components/organisms/TheEvent/TheEvent.vue'
import { useEventTypeStore } from '@/stores/eventTypeStore'
import type { EventDto } from '@/types'
const props = defineProps<{
    id: string
}>()
const eventStore = useEventStore()
let event:EventDto|undefined = undefined

onBeforeMount(() => {

    useEventTypeStore().loadAll()
    if (!isNaN(parseInt(props.id))) {
        eventStore.getEvent(parseInt(props.id, 10))
        event = storeToRefs(eventStore).event.value
        const imageUrlOld = `${import.meta.env.VITE_IMAGES_BASE_URL}/${event?.value?.image.url}`
        const imageUrl = `${event?.value?.image.url}`
    }

    //console.log('event', JSON.stringify(event))


})

</script>
<template>
    
    <TheEvent v-show="event !== undefined" :event="event" :image-url="imageUrl" />
</template>

<style lang="scss" scoped></style>
